import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import TagManager from 'react-gtm-module'
import { I18nextProvider } from 'react-i18next'
import { HydratedRouter } from 'react-router/dom'

import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

import InternalCookie from '@/entities/internalCookie'
import { initI18next } from '@/shared/i18n/i18next.client'

if (import.meta.env.MODE !== 'development') {
	const tagManagerArgs = {
		gtmId: import.meta.env.VITE_GOOGLE_ANALYTICS_TAG_MANAGER
	}

	TagManager.initialize(tagManagerArgs)
}

if (InternalCookie.checkInUrlParams()) {
	// eslint-disable-next-line no-console
	console.log('Internal flag detected! Set internal cookie!')
	InternalCookie.set()
}

const hydrate = async () => {
	const emotionCache = createCache({ key: 'css' })

	const i18next = await initI18next()

	React.startTransition(() => {
		ReactDOM.hydrateRoot(
			document,
			<I18nextProvider i18n={i18next}>
				<CacheProvider value={emotionCache}>
					<HydratedRouter />
				</CacheProvider>
			</I18nextProvider>
		)
	})
}

if (window.requestIdleCallback) {
	window.requestIdleCallback(hydrate)
} else {
	// Safari doesn't support requestIdleCallback
	// https://caniuse.com/requestidlecallback
	setTimeout(hydrate, 1)
}
